import { Loader } from "lucide-react";
import { FC } from "react";

import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { useDeleteVideoMutation } from "@/data/mutations";
import { Video } from "@/data/types";
import { useDialogState } from "@/hooks/use-dialog-state";

export const DeleteVideoDialog: FC<Video> = (video) => {
  const { dialog, closeDialog } = useDialogState();
  const deleteVideoMutation = useDeleteVideoMutation();

  const handleSubmit = () => {
    deleteVideoMutation.mutate(video.id);
  };

  return (
    <AlertDialog open={dialog?.name === "delete-video"}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Video {video.file_name}</AlertDialogTitle>
          <AlertDialogDescription>
            Video {video.file_name} will be deleted. This action is
            irreversible.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button
            variant="outline"
            onClick={closeDialog}
            disabled={deleteVideoMutation.isPending}
          >
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={handleSubmit}
            disabled={deleteVideoMutation.isPending}
          >
            {deleteVideoMutation.isPending ? (
              <Loader className="animate-spin" />
            ) : null}
            Delete
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
